import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconIndicator(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M6 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z" fill="currentColor" />
    </BaseIcon>
  );
}
